<template>
  <div>
    <Modal v-model="showModel" title="租赁框架协议列表" width="45" :styles="{ 'z-index': '20' }">
      <table-title>租赁框架协议列表</table-title>
      <data-grid v-if="tatbleShow" :columns="frameRentCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="frameRentList">
        <template #default="{ columns, data }">
          <Table :columns="columns" :data="data" :width="800" border stripe size="small" style="margin: 10px"></Table>
        </template>
      </data-grid>
      <table-title>计费增值费列表</table-title>
      <data-grid v-if="tatbleShow" :columns="addedFeeCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="addedFeeList">
        <template #default="{ columns, data }">
          <Table :columns="columns" :data="data" :width="800" border stripe size="small" style="margin: 10px"></Table>
        </template>
      </data-grid>
      <table-title>计费模型附加运费列表</table-title>
      <Table v-if="tatbleShow" :columns="adtlRecycleCols" :data="adtlRecycleList" border stripe size="small" :width="800" style="margin: 10px"></Table>
      <table-title>计费模型区域运费列表</table-title>
      <!-- <Table v-if="tatbleShow" :columns="areaLogisticsCols" :data="areaLogisticsList" border stripe size="small" :width="800" style="margin:10px"></Table> -->
      <data-grid v-if="tatbleShow" :columns="areaLogisticsCols" :queryParams="{}" :autoLoad="false" :pagination="false" subListName :dataList="areaLogisticsList">
        <template #default="{ columns, data }">
          <Table :columns="columns" :data="data" :width="800" border stripe size="small" style="margin: 10px"></Table>
        </template>
      </data-grid>
      <table-title>计费模型阶梯列表</table-title>
      <Table v-if="tatbleShow" :columns="stairFeeCols" :data="stairFeeList" border stripe size="small" :width="800" style="margin: 10px"></Table>
      <div style="text-align: center">
        <!-- <Button type="primary" @click="submit">提交</Button> -->
        <!-- <Button
          type="warning"
          style="margin-left: 10px"
          @click="$emit('onFinish')"
          >返回</Button
        > -->
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Modal>
  </div>
</template>

<script>
import tableTitle from "@/components/tableTitle/tableTitle.vue";
import dataGrid from "@/components/datagrid.vue";
export default {
  props: ["paramsData"],
  components: { tableTitle, dataGrid },
  data() {
    return {
      showModel: false,
      spinShow: true,
      tatbleShow: true,
      frameRentList: [], //租赁框架协议列表
      frameRentCols: [
        { title: "框架协议编号", key: "id" },
        { title: "计价模型编号", key: "billingModelId" },
        { title: "动态策略编号", key: "strategyId" },
        {
          title: "参与人",
          key: "memberId",
          dict: ["bizObjects", "member", true],
        },
        {
          title: "指定合伙人",
          key: "leaserId",
          dict: ["bizObjects", "member", true],
        },
        {
          title: "标的物小类",
          key: "targetType",
          dict: ["target", "type", true],
        },
        {
          title: "是否默认框架协议",
          key: "defaultFlag",
          dict: ["default", "bitYesNo"],
        },
        {
          title: "计费模式类型",
          key: "billingModeType",
          dict: ["default", "billingModeType"],
        },
        { title: "约定期限", key: "rentTerm" },
        { title: "免费租期", key: "noBillingTerm" },
        {
          title: "模式类型",
          key: "modelId",
          dict: ["default", "billingModel"],
        },
      ],
      addedFeeList: [],
      addedFeeCols: [
        { title: "计费模型编号", key: "billingModelId" },
        { title: "增值费类型", key: "feeType", dict: ["default", "feeType"] },
        { title: "增值费单价", key: "unitPrice" },
        {
          title: "背对背标志",
          key: "backToBackFlag",
          dict: ["default", "bitYesNo"],
        },
      ],
      adtlRecycleList: [], //计费模型附加运费列表
      adtlRecycleCols: [
        { title: "计费模型编号", key: "billingModelId" },
        { title: "开始天数", key: "startDays" },
        { title: "截止天数", key: "endDays" },
        { title: "附加运费单价", key: "adtlRecyclePrice" },
      ],
      areaLogisticsList: [], //计费模型区域运费列表
      areaLogisticsCols: [
        { title: "计费模型编号", key: "billingModelId" },
        { title: "省市区", key: "areaId", dict: ["region", "fullArea", true] },
        { title: "配送费单价", key: "deliverPrice" },
        { title: "回收费单价", key: "recyclePrice" },
      ],
      stairFeeList: [], //计价模型阶梯列表
      stairFeeCols: [
        { title: "计费模型编号", key: "billingModelId" },
        { title: "开始天数", key: "startDays" },
        { title: "截止天数", key: "endDays" },
        { title: "租金价格 ", key: "rentalPrice" },
        { title: "服务费价格 ", key: "servicePrice" },
      ],
    };
  },
  created() {
    this.getData(this.paramsData);
  },
  methods: {
    init() {
      this.showModel = true;
    },
    getData(frameId) {
      let data = {
        url: "CORE-CONTRACT/messageService/queryService/queryFrame",
        body: { frameId },
      };
      this.tatbleShow = false;
      this.invoke(data).then((res) => {
        if (res) {
          this.addedFeeList = res.BillingModelAddedFeeList;
          this.adtlRecycleList = res.BillingModelAdtlRecycleFeeList;
          this.areaLogisticsList = res.BillingModelAreaLogisticsList;
          this.stairFeeList = res.BillingModelStairFeeList;
          delete res.billingModel.id;
          let obj = { ...res.frame_rent, ...res.billingModel };
          this.frameRentList.push(obj);
          this.tatbleShow = true;
          this.spinShow = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>